import React from 'react';

const Equipment = () => {
  return (
    <section id="equipment">
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">Equipment Collection</h2>
        <div className="text-center">
          <p className="mb-4 text-gray-600">
            Our equipment collection is available on our dedicated website.
          </p>
          <a
            href="https://mdxequipment.com/collections/flame-retardant-resistant-clothing"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-6 py-3 bg-orange-600 text-white rounded-lg shadow-lg hover:bg-orange-700 transition-colors"
          >
            Visit Equipment Collection
          </a>
        </div>
      </div> */}
    </section>
  );
};

export default Equipment;
